export type Marker = {
  label: string
  value: number
  options?: Record<string, string>
}

export type Region = {
  label: string
  start: number
  end: number
  options?: Record<string, string>
}

export const DEFAULT_AXIS_OPTIONS = {
  shortenYAxisNumbers: true
}
